import React, { useEffect } from 'react'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { african_doctor } from '../../constant/Image'
import { auth } from '../../firebase/utils'
import { selectCartItems, selectCartItemsCount } from '../../redux/Cart/cart.selectors'
import { getMessageStart, setMessagesFailStart } from '../../redux/Chat/chat.action'
import { fetchDoctorsStart } from '../../redux/Doctors/doctors.action';
import { ChatContainer } from './Chat.styled'
import ChatForm from './ChatForm'

const mapState = (state) => {
  return {
    doctors:state.doctors.doctors,
    currentUser: state.user.currentUser,
    conversations:state.chat.conversations
  }
}
function Chat() {
  const {doctors,currentUser,conversations} = useSelector(mapState);
  const dispatch = useDispatch();
  const [chatUser, setChatUser] = useState('');
  const [userName, setUserName] = useState(null);
  const [chatStarted, setChatStarted] = useState(false);
  useEffect(() => {
    dispatch(fetchDoctorsStart());
  },[]);

  const handleClickedUser = (doctor) => {
    setChatStarted(true);
    dispatch(setMessagesFailStart());
    setChatUser(doctor.doctorName);
    setUserName(doctor.doctorName);
    
    dispatch(getMessageStart({userName_1: currentUser.displayName, userName_2:doctor.doctorName}));
  }

  return (
    <ChatContainer>
        <div className='chatContent'>
            <div className='chatting'>
                <div className='card'>
                  <div className='receiver_name'>{chatStarted ? chatUser :''}</div>
                  {chatStarted ? 
                  <div className='messaging'>
                    {
                      conversations.length > 0 ? 
                      conversations.map((con) => 
                      {
                        if(con != undefined){
                          return (
                            <>
                              <div className={con.user_name_1 == currentUser.displayName ? 'sender_text':'reciever_text'}>
                                <span>{con.message}</span>
                              </div>
                            </>
                          )
                        }else {
                          return null;
                        }
                        
                      })
                      : null
                    }
                  </div>
                  : <div>Chat with doctor</div>}
                    
                  {chatStarted ?<ChatForm userName={userName}  /> : null}
                </div>
            </div>
            <div className='group'>
            <div className='card full-height'>
              <div className='users_section'>
                <div className='users_header'>
                  <h3>FarmaChat</h3>
                  <span>chat with our community.</span>
                </div>
                
                {doctors.length > 0 &&
                  doctors.map((doc, index) => (
                    <div className='user_profile' onClick={() => handleClickedUser(doc)}>
                      <div className='profile' id={`doctor-${doc.id+1}`}><img src={doc.doctorImage} /></div>
                      <span>{doc.doctorName}</span>
                    </div>
                  ))
                }
                {doctors.length <= 0 && 
                <div>Loading Data...</div>}
                  
              </div>
            </div>
            </div>
        </div>
    </ChatContainer>
  )
}

export default Chat